import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ConditionalRendering } from '../common/conditional-rendering';
import verificationsHelper from '../../modules/dmi-verifications/helpers/verificationsHelper';

interface IVerificationsTab {
    name: string;
    index: number;
    selectedIndex: number | null;
    onSelect: () => void;
    isDocumentCategoryVerified: boolean;
    isCheckIconVisible?: boolean;
}

const StyledTabContainer = styled.div`
    display: flex;
    flex-direction: column;

    .user-icon {
        margin-left: 5px;
        margin-right: 5px;
        color: ${({ theme }) => theme.dangerMain};
    }

    .icon-check {
        color: ${({ theme }) => theme.successMain};
    }

    .user-details {
        padding: 10px;
        width: calc(100% + 1px);
        cursor: pointer;
        color: ${({ theme }) => theme.primaryDark};
    }

    .selected {
        z-index: 1;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-right: 0px !important;
        border: ${({ theme }) => `1px solid ${theme.gray8}`};
        background: ${({ theme }) => theme.defaultWhite};
        color: ${({ theme }) => theme.gray2};
        @media (max-width: 980px) {
            border: ${({ theme }) => `1px solid ${theme.gray8}`};
            border-bottom: 0px !important;
            border-bottom-left-radius: 0px;
            border-right: ${({ theme }) => `1px solid ${theme.gray8}`} !important;
            border-top-right-radius: 5px;
            margin-bottom: -1px;
        }
    }
`;

const StyledTabs = styled.div``;

const VerificationsTab = ({ name, index, selectedIndex, onSelect, isDocumentCategoryVerified, isCheckIconVisible }: IVerificationsTab) => {
    const isSelected = index === selectedIndex;
    const { createKeyboardHandler } = verificationsHelper();

    return (
        <StyledTabContainer>
            <StyledTabs
                className={isSelected ? 'user-details selected' : 'user-details'}
                onClick={onSelect}
                onKeyDown={createKeyboardHandler(onSelect)}
                tabIndex={0}
                role="tab"
                aria-selected={isSelected}
                data-testid={`dmi-verifications-applicantTabs-${name}`}
            >
                <span className="h3">{name}</span>
                <ConditionalRendering isTrue={!isDocumentCategoryVerified}>
                    <FontAwesomeIcon icon={faExclamationCircle} className="user-icon xs" data-testid="warning-icon" />
                </ConditionalRendering>
                <ConditionalRendering isTrue={isDocumentCategoryVerified && isCheckIconVisible}>
                    <FontAwesomeIcon icon={faCheckCircle} className="user-icon icon-check xs" data-testid="check-icon" />
                </ConditionalRendering>
            </StyledTabs>
        </StyledTabContainer>
    );
};

export default VerificationsTab;
